import React from 'react';
import { Flex, Image, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import couponApply from './coupon-apply.png';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

export const FAQSection = () => {
  const { t } = useTranslation();
  const [expandedKey, setExpandedKey] = React.useState<string | null>(null);

  const faqItems = [
    { key: '1', question: t('billing.faq.q1'), answer: t('billing.faq.a1') },
    {
      key: '1.5',
      question: t('billing.faq.q1_5'),
      answer: t('billing.faq.a1_5'),
    },
    { key: '2', question: t('billing.faq.q2'), answer: t('billing.faq.a2') },
    {
      key: '2.5',
      question: t('billing.faq.q2_5'),
      answer: t('billing.faq.a2_5'),
    },
    { key: '3', question: t('billing.faq.q3'), answer: t('billing.faq.a3') },
    {
      key: '3.5',
      question: t('billing.faq.q3_5'),
      answer: (
        <Flex style={{ flexDirection: 'column' }}>
          <span>{t('billing.faq.a3_5')}</span>
          <Image src={couponApply} />
        </Flex>
      ),
    },
    { key: '4', question: t('billing.faq.q4'), answer: t('billing.faq.a4') },
    { key: '5', question: t('billing.faq.q5'), answer: t('billing.faq.a5') },
    { key: '6', question: t('billing.faq.q6'), answer: t('billing.faq.a6') },
    { key: '7', question: t('billing.faq.q7'), answer: t('billing.faq.a7') },
    { key: '8', question: t('billing.faq.q8'), answer: t('billing.faq.a8') },
    { key: '9', question: t('billing.faq.q9'), answer: t('billing.faq.a9') },
    { key: '10', question: t('billing.faq.q10'), answer: t('billing.faq.a10') },
  ];

  return (
    <div style={{ padding: '40px 24px' }}>
      <Title level={2} style={{ marginBottom: 32 }}>
        {t('billing.faq.title')}
      </Title>
      <div
        style={{
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          overflow: 'hidden',
        }}
      >
        {faqItems.map((item) => (
          <div
            key={item.key}
            style={{
              borderBottom:
                item.key !== faqItems[faqItems.length - 1].key
                  ? '1px solid #f0f0f0'
                  : 'none',
            }}
          >
            <div
              onClick={() =>
                setExpandedKey(expandedKey === item.key ? null : item.key)
              }
              style={{
                padding: '16px 24px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#fff',
                transition: 'background-color 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#fafafa';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
              }}
            >
              <span style={{ fontSize: 16 }}>{item.question}</span>
              <RightOutlined
                style={{
                  transform:
                    expandedKey === item.key ? 'rotate(90deg)' : 'none',
                  transition: 'transform 0.3s',
                }}
              />
            </div>
            <div
              style={{
                padding: expandedKey === item.key ? '16px 24px' : '0 24px',
                maxHeight: expandedKey === item.key ? '500px' : '0',
                overflow: 'hidden',
                transition: 'all 0.3s ease-in-out',
                background: '#fafafa',
              }}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
